'use strict';
import Promise from 'bluebird';
import $ from 'jquery';
import getToken from './token';

const BASE_URL = '/fi/api/v1/reviews/';

export const getReviews = (productId, page = 1, limit = 4) => {
	return Promise.resolve($.get(`${BASE_URL}?productId=${productId}&page=${page}&limit=${limit}`));
}

export const getAverage = (productId) => {
	return Promise.resolve($.get(`${BASE_URL}?productId=${productId}&average=true`));
}

export const vote = (reviewId, vote, action) => {
	getToken().then(token => Promise.resolve($.post(`${BASE_URL}vote/${reviewId}/${vote}`, { token, action })));
}